<template>
  <ion-grid>
    <ion-row>
      <ion-col
        size-md="6"
        size-lg="5"
        size-xs="12"
      >
        <form @submit.prevent="reset">
          <div class="ion-text-center">
            <ion-text color="light">
              <h1>Forgot password</h1>
            </ion-text>
          </div>
          <div class="ion-padding">
            <ion-input-vue
              v-model="credentials.email"
              color="light"
              type="email" 
              placeholder="Email" 
              required
            />
            <template v-if="token">
              <ion-input-vue
                v-model="credentials.password"
                color="light"
                type="password" 
                placeholder="Password"
                minlength="8"
                required
                @ionChange="validate"
              />

              <ion-input-vue
                ref="passwordConfirmation"
                v-model="credentials.password_confirmation"
                color="light"
                type="password" 
                placeholder="Confirm password" 
                minlength="8"
                required
                @ionChange="validate"
              />
            </template>
          </div>
          <div class="ion-padding">
            <ion-button
              :disabled="invalid"
              class="ion-margin-top"
              style="border-width: 0"
              color="light" 
              size="large" 
              type="submit" 
              expand="block"
            >
              <ion-spinner
                v-if="busy"
                color="dark"
              />
              <ion-text
                v-else
                color="dark"
              >
                <template v-if="token">
                  Reset password
                </template>
                <template v-else>
                  Send password reset link
                </template>
              </ion-text>
            </ion-button>
          </div>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import { IonInputVue } from '@modus/ionic-vue'
import { toastController } from '@modus/ionic-vue'

export default {
  components: {
    IonInputVue
  },
  data() {
    return {
      credentials: {
        email: '',
        password: '',
        password_confirmation: '',
        token: ''
      },
      busy: false
    }
  },
  computed: {
    valid() {
      const credentials = this.credentials

      if(this.token) {
        return credentials.email && credentials.password && credentials.password_confirmation
      }

      return credentials.email
    },
    invalid() {
      return !this.valid
    },
    token() {
      return this.$route.params.token;
    },
    action() {
      return this.token ? 'resetPassword' : 'requestPasswordReset'
    }
  },
  created() {
    this.credentials.token = this.token;
  },
  methods: {
    reset() {
      this.busy = true

      this.$store.dispatch(this.action, this.credentials)
        .then(() => this.handleSuccess())
        .finally(() => this.busy = false)
    },
    handleSuccess() {
      if(!this.token) {
        return
      }

      this.$router.push({ name: 'login' })
    },
    validate() {
      const credentials = this.credentials

      this.$refs.passwordConfirmation.firstChild.setCustomValidity(
        credentials.password !== credentials.password_confirmation 
          ? "Passwords don't match"
          : ''
      )
    }
  }
}
</script>

<style scoped>
ion-grid {
  height: 100%;
}
ion-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
ion-col {
  background: var(--ion-color-secondary);
}

ion-input {
  border-bottom: 1px solid var(--ion-color-light);
}

ion-button {
  font-weight:300;
}

.forgot-password {
  cursor:pointer;
}
</style>